import { render, staticRenderFns } from "./baoxianInfo.vue?vue&type=template&id=519ea90a&scoped=true"
import script from "./baoxianInfo.vue?vue&type=script&lang=js"
export * from "./baoxianInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ea90a",
  null
  
)

export default component.exports